<div
  class="ui-identity-photo-capture"
  [class.ui-identity-photo-capture--disabled]="disabled()"
  [class.ui-identity-photo-capture--invalid]="invalid()"
  [class.ui-identity-photo-capture--has-preview]="hasPreview()"
>
  <div class="ui-identity-photo-capture__header">
    <label class="ui-identity-photo-capture__label" [attr.for]="inputId()">
      {{ label() }}
    </label>
    @if (showRequirement()) {
      <span
        class="ui-identity-photo-capture__requirement"
        [class.ui-identity-photo-capture__requirement--error]="invalid() && required()"
        aria-hidden="true"
      >
        {{ requirementText() }}
      </span>
    }
  </div>

  @if (description()) {
    <p class="ui-identity-photo-capture__description" [id]="descriptionId()">
      {{ description() }}
    </p>
  }

  <button
    type="button"
    class="ui-identity-photo-capture__frame"
    [class.ui-identity-photo-capture__frame--invalid]="invalid()"
    [disabled]="disabled() || (cameraActive() && !cameraReady())"
    [attr.aria-label]="hasPreview() ? retakeLabel() : buttonLabel()"
    (click)="onPrimaryAction(photoInput)"
  >
    @if (previewSrc()) {
      <img
        class="ui-identity-photo-capture__preview"
        [src]="previewSrc()!"
        [alt]="previewAlt()"
      />
    } @else if (isCameraMode() && cameraActive() && !captureInDrawer()) {
      <video
        #cameraVideo
        class="ui-identity-photo-capture__video"
        autoplay
        muted
        playsinline
      ></video>
    } @else {
      <div class="ui-identity-photo-capture__placeholder" aria-hidden="true">
        <svg
          class="ui-identity-photo-capture__icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
          focusable="false"
        >
          <path d="M4 7h3l1.4-2h7.2L17 7h3a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z" />
          <circle cx="12" cy="13" r="3.2" />
        </svg>
        <span>{{ placeholder() }}</span>
      </div>
    }
  </button>

  <input
    #photoInput
    class="ui-identity-photo-capture__input"
    type="file"
    [id]="inputId()"
    [accept]="accept()"
    [attr.capture]="captureAttr()"
    [disabled]="disabled()"
    [attr.aria-describedby]="ariaDescribedBy()"
    [attr.aria-invalid]="invalid() ? 'true' : null"
    [attr.aria-required]="required() ? 'true' : null"
    (change)="onFileChange($event)"
  />

  <div class="ui-identity-photo-capture__actions">
    <button
      type="button"
      class="ui-identity-photo-capture__action ui-identity-photo-capture__action--primary"
      [disabled]="disabled() || (cameraActive() && !cameraReady())"
      (click)="onPrimaryAction(photoInput)"
    >
      {{ primaryActionLabel() }}
    </button>

    @if (hasPreview()) {
      <button
        type="button"
        class="ui-identity-photo-capture__action ui-identity-photo-capture__action--ghost"
        [disabled]="disabled()"
        (click)="clearPhoto()"
      >
        {{ clearLabel() }}
      </button>
    }
  </div>

  @if (cameraError()) {
    <p class="ui-identity-photo-capture__message" role="alert">
      {{ cameraError() }}
    </p>
  }

  @if (message() && invalid() && showMessage()) {
    <p
      class="ui-identity-photo-capture__message"
      [id]="messageId()"
      role="alert"
    >
      {{ message() }}
    </p>
  }
</div>

@if (captureInDrawer()) {
  <ui-drawer
    [open]="cameraDrawerOpen()"
    (openChange)="onCameraDrawerOpenChange($event)"
    [title]="cameraDrawerTitle()"
    placement="center"
    cancelLabel="Cancelar"
    [showSaveButton]="false"
  >
    <div class="ui-identity-photo-capture__camera-drawer">
      <div class="ui-identity-photo-capture__camera-stage">
        <div class="ui-identity-photo-capture__camera-viewport">
          @if (cameraActive()) {
            <video
              #cameraVideo
              class="ui-identity-photo-capture__camera-video"
              autoplay
              muted
              playsinline
            ></video>
            <span
              #cameraGuide
              class="ui-identity-photo-capture__camera-guide"
              aria-hidden="true"
            ></span>
          } @else if (cameraError()) {
            <p class="ui-identity-photo-capture__camera-error" role="alert">
              {{ cameraError() }}
            </p>
          }
        </div>
      </div>

      <div class="ui-identity-photo-capture__camera-actions">
        <button
          type="button"
          class="ui-identity-photo-capture__action ui-identity-photo-capture__action--primary"
          [disabled]="!cameraReady()"
          (click)="captureFromDrawer()"
        >
          {{
            captureInProgress()
              ? processingLabel()
              : cameraReady()
                ? captureLabel()
                : focusingLabel()
          }}
        </button>
      </div>
    </div>
  </ui-drawer>
}
